import { IActionContext } from '../helpers/ActionContext';
import { L10n } from '../L10n/L10n';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ServerUsers } from '../resources/ServerUsers';
import { IResult } from '../ServerApi/types/IResponse';
import { IServerUser } from '../ServerApi/types/IServerUser';
import { ISiteUser } from '../ServerApi/types/ISiteUser';
import { IUser } from '../ServerApi/types/IUser';
import { IUserActionResult, UserActionResultCode } from '../ServerApi/types/IUserActionResult';
import { ConfirmActionDialog } from './ConfirmActionDialog';
import { ConfirmationBasedAction, ConfirmationBasedActionMetadata } from './ConfirmationBasedAction';

export class ForcePasswordUpdateAction {

  public static $inject = ['$translate',
                           'ConfirmActionDialog',
                           'ServerUsers'];

  private static DIALOG_BODY: string = 'confirmForcePasswordUpdate';
  private static DIALOG_TITLE: string = 'forcePasswordUpdateTitle';
  private static ACTION_NAME: string = 'confirmForcePasswordUpdateButton';

  private confirmationBasedSiteAction: ConfirmationBasedAction;
  private confirmationBasedServerAction: ConfirmationBasedAction;

  constructor(
    private $translate: ng.translate.ITranslateService,
    private ConfirmActionDialog: ConfirmActionDialog,
    private ServerUsers: ServerUsers) {
    this.confirmationBasedSiteAction = this.createAction(this.ServerUsers.forcePasswordUpdateOnSiteUsers.bind(this.ServerUsers));
    this.confirmationBasedServerAction = this.createAction(this.ServerUsers.forcePasswordUpdate.bind(this.ServerUsers));
  }

  private createAction(requestTrigger: (userIds: string[]) => ng.IPromise<IUserActionResult>): ConfirmationBasedAction {
    const actionMetadata: ConfirmationBasedActionMetadata = {
      dialogBody: ForcePasswordUpdateAction.DIALOG_BODY,
      dialogTitle: ForcePasswordUpdateAction.DIALOG_TITLE,
      actionName: ForcePasswordUpdateAction.ACTION_NAME,
      trigger: requestTrigger,
      actionSuccessCode: UserActionResultCode.userForcedPasswordUpdate
    };
    return new ConfirmationBasedAction(this.$translate, this.ConfirmActionDialog, actionMetadata);
  }

  public onSiteUsers(context: IActionContext, siteUsers: Set<ISiteUser>): ng.IPromise<IResult> {
    return this.confirmationBasedSiteAction.runOn(context, siteUsers);
  }

  public onServerUsers(context: IActionContext, siteUsers: Set<IServerUser>): ng.IPromise<IResult> {
    return this.confirmationBasedServerAction.runOn(context, siteUsers);
  }
}

Module.instance().service('ForcePasswordUpdateAction', ForcePasswordUpdateAction);
